import type { Activity } from '@paintscout/api'
import React from 'react'
import { formatName } from '@paintscout/util/builder'
import Highlight from '@paintscout/ui/components/Highlight'

export interface ActivityContactProps {
  activity: Activity
  prefix?: string
}

export default function ActivityContact(props: ActivityContactProps) {
  const { activity, prefix = 'by' } = props

  const contact = activity.details.contact
  const name = formatName(contact)

  if (!name) {
    return null
  }

  return (
    <>
      {' '}
      {prefix} <Highlight>{name}</Highlight>
    </>
  )
}
